import styled, { css } from 'styled-components';
import { lineHeight, theme, toRem } from 'design';

interface IRowProps {
  bgColor?: 'default' | 'transparent' | 'white';
  clickable?: boolean;
  isActive?: boolean;
}

const Row = styled.tr<IRowProps>`
  position: relative;
  z-index: ${theme.zIndex.content};
  width: 100%;
  margin-bottom: ${toRem(theme.space.md)};
  padding: 0;
  border-radius: ${toRem(5.5)};
  border-bottom: ${toRem(1)} solid ${theme.color.neutral[200]};
  background-color: ${theme.color.white};
  transition: all ${theme.transition.button.default};
  font-family: ${theme.font.family.euclid};
  font-weight: ${theme.font.weight.regular};
  font-size: ${toRem(theme.font.size.sm)};
  line-height: ${lineHeight(theme.font.size.sm)};
  text-align: left;
  color: ${theme.color.neutral[900]};
  overflow: hidden;

  &:last-child {
    margin-bottom: 0;
    border-bottom: none;

    td {
      border-bottom: none;
    }
  }

  &:hover {
    background-color: ${theme.color.neutral[50]};
  }

  ${({ isActive }) =>
    isActive &&
    css`
      border-left-color: ${theme.color.secondary[300]};
      background-color: ${theme.color.neutral[50]};
    `}

  ${({ bgColor }) =>
    bgColor === 'transparent' &&
    css`
      background-color: transparent;
    `}

  ${({ bgColor }) =>
    bgColor === 'white' &&
    css`
      background-color: ${theme.color.white};
    `}


  ${({ clickable }) =>
    clickable &&
    css`
      cursor: pointer;
    `}
`;

export default Row;
